<template>
  <v-layout row wprap>
    <v-flex
      v-if="modifiedFileTransfertConfig && mission.misActifOn && accessConfigFileTransfert.enable"
      xs6
      py-4
      pl-4
      pr-2
      style="display: flex; flex-direction: column; height: 100%; overflow: auto"
    >
      <v-card class="mb-3" style="flex: 0 1 auto">
        <v-card-title class="pb-0" style="flex-direction: column; align-items: start">
          <span class="subheading mb-1" style="flex: 0 0 auto">{{ $t('Pilot.FileTransfert.Configuration') }}</span>
          <v-switch
            hide-details
            class="pb-2 sm-switch"
            v-model="config.enableDownload"
            @change="saveConfig"
            :label="$t('Pilot.FileTransfert.EnableDownload')"
            style="flex: 0 0 auto"
          />
          <div class="flex-container" :class="{ disable: !config.enableDownload }">
            <div class="flex-container">
              <v-card
                ref="prioritybox1"
                class="mb-3 mx-0 pr-4"
                :style="{ order: config.priority.indexOf('standard') + 1 }"
              >
                <div class="position">{{ config.priority.indexOf('standard') + 1 }}</div>
                <v-card-title style="background-color: #fafafa">
                  <v-btn @click.prevent="orderup('standard')" small icon class="btnup">
                    <v-icon>mdi-menu-up</v-icon>
                  </v-btn>
                  <span class="subheading">{{ $t('Pilot.FileTransfert.LastFileTitle') }}</span>
                  <v-layout row wrap mt-2>
                    <v-flex xs6 pr-2>
                      <v-text-field
                        v-model="config.nbDownLastNavFile"
                        :label="$t('Pilot.FileTransfert.NavFieldName')"
                      />
                      <v-switch
                        class="px-0 pb-2 sm-switch"
                        hide-details
                        v-model="config.enableCatchUpNav"
                        :label="$t('Pilot.FileTransfert.EnableCatchUp')"
                      />
                    </v-flex>
                    <v-flex xs6 pl-2>
                      <v-text-field
                        v-model="config.nbDownLastPldFile"
                        :label="$t('Pilot.FileTransfert.PldFieldName')"
                      />
                      <v-switch
                        class="px-0 pb-2 sm-switch"
                        hide-details
                        v-model="config.enableCatchUpPld"
                        :label="$t('Pilot.FileTransfert.EnableCatchUp')"
                      />
                    </v-flex>
                  </v-layout>
                  <v-btn @click.prevent="orderdown('standard')" small icon class="btndown">
                    <v-icon>mdi-menu-down</v-icon>
                  </v-btn>
                </v-card-title>
              </v-card>
              <v-card
                ref="prioritybox2"
                class="mb-3 mx-0 pr-4"
                :style="{ order: config.priority.indexOf('listFixed') + 1 }"
              >
                <div class="position">{{ config.priority.indexOf('listFixed') + 1 }}</div>
                <v-card-title style="background-color: #fafafa">
                  <v-btn @click.prevent="orderup('listFixed')" small icon class="btnup">
                    <v-icon>mdi-menu-up</v-icon>
                  </v-btn>
                  <span class="subheading">{{ $t('Pilot.FileTransfert.SpecificFileTitle') }}</span>
                  <v-container class="flex pa-0">
                    <v-layout row wrap mt-2>
                      <v-flex xs6 style="border-right: 1px solid #ccc">
                        <span class="body-2">{{ $t('Pilot.FileTransfert.NavFieldName') }}</span>
                        <br />
                        <div style="max-height: 100px; overflow: auto">
                          <v-chip
                            small
                            close
                            v-for="cycle in orderedSpecificsNavFiles"
                            :key="cycle"
                            @input="removeFromNavRequested(cycle)"
                          >
                            {{ cycle }}
                          </v-chip>
                        </div>
                      </v-flex>
                      <v-flex xs6 pl-2>
                        <span class="body-2">{{ $t('Pilot.FileTransfert.PldFieldName') }}</span>
                        <br />
                        <div style="max-height: 100px; overflow: auto">
                          <v-chip
                            small
                            close
                            v-for="cycle in orderedSpecificsPldFiles"
                            :key="cycle"
                            @input="removeFromPldRequested(cycle)"
                          >
                            {{ cycle }}
                          </v-chip>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-container>
                  <div class="filelist-section mt-2">
                    <span class="body-2">{{ $t('Pilot.FileTransfert.FileList') }}</span>
                    <v-layout row align-center mt-1>
                      <v-flex>
                        <v-text-field v-model="newFileNfInput" hide-details single-line @keyup.enter="addFileNf" />
                      </v-flex>
                      <v-btn @click.prevent="addFileNf" small icon class="ml-2">
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </v-layout>
                    <div style="max-height: 100px; overflow: auto" class="mt-1">
                      <v-chip
                        small
                        close
                        v-for="entry in config.specificsFilesNf"
                        :key="entry"
                        @input="removeFileNf(entry)"
                      >
                        {{ entry }}
                      </v-chip>
                    </div>
                  </div>
                  <v-btn @click.prevent="orderdown('listFixed')" small icon class="btndown">
                    <v-icon>mdi-menu-down</v-icon>
                  </v-btn>
                </v-card-title>
              </v-card>
              <v-card
                ref="prioritybox3"
                class="mb-3 mx-0 pr-4"
                :style="{ order: config.priority.indexOf('multi_yo') + 1 }"
              >
                <div class="position">{{ config.priority.indexOf('multi_yo') + 1 }}</div>
                <v-card-title style="background-color: #fafafa">
                  <v-btn @click.prevent="orderup('multi_yo')" small icon class="btnup">
                    <v-icon>mdi-menu-up</v-icon>
                  </v-btn>
                  <span class="subheading">{{ $t('Pilot.FileTransfert.MultiYoPolicy') }}</span>
                  <v-layout row wrap mt-2>
                    <v-flex xs6 pr-2>
                      <v-select
                        v-model="config.firstFile"
                        :items="multiYoFileItems"
                        :label="$t('Pilot.FileTransfert.FirstFile')"
                      />
                    </v-flex>
                    <v-flex xs6 pl-2>
                      <v-select
                        v-model="config.lastFile"
                        :items="multiYoFileItems"
                        :label="$t('Pilot.FileTransfert.LastFile')"
                      />
                    </v-flex>
                  </v-layout>
                  <v-btn @click.prevent="orderdown('multi_yo')" small icon class="btndown">
                    <v-icon>mdi-menu-down</v-icon>
                  </v-btn>
                </v-card-title>
              </v-card>
            </div>
          </div>
        </v-card-title>
        <v-card-actions class="pr-3">
          <v-spacer />
          <!--<v-btn @click.prevent="resetConfig" small >{{$t('Pilot.FileTransfert.ResetConfig')}}<v-icon small right>mdi-backup-restore</v-icon></v-btn>-->
          <v-btn @click.prevent="restoreConfig" :disabled="!btnActif" small>
            {{ $t('Pilot.FileTransfert.RestoreConfig') }}
            <v-icon small right>mdi-replay</v-icon>
          </v-btn>
          <v-btn @click.prevent="saveConfig" :disabled="!btnActif" small color="primary">
            {{ $t('Pilot.FileTransfert.ValidateConfig') }}
            <v-icon small right>mdi-content-save</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card style="flex: 1 0 auto">
        <v-card-title style="display: flex; flex-direction: row; flex-wrap: wrap; align-items: start">
          <span style="width: 100%" class="xs12 subheading mb-1">
            {{ $t('Pilot.FileTransfert.FileRequestedNextSurfacing') }}
          </span>
          <template v-if="config.filesRequested.length > 0 && config.enableDownload">
            <div style="max-height: 60px; overflow: auto">
              <v-chip small v-for="(request, index) in config.filesRequested" :key="index">
                <v-avatar color="#ccc" class="darken-1">{{ index + 1 }}</v-avatar>
                {{ request }}
              </v-chip>
            </div>
          </template>
          <span v-else>{{ $t('Pilot.FileTransfert.NoRequestedFile') }}</span>
        </v-card-title>
      </v-card>
    </v-flex>
    <v-flex v-else xs6 py-4 pl-4 pr-2 style="display: flex; flex-direction: column; height: 100%; overflow: auto">
      <v-card style="flex: 1 1 auto">
        <v-card-title class="pb-0" style="flex-direction: column; align-items: start">
          {{ $t('Pilot.FileTransfert.NoDataAvailable') }}
        </v-card-title>
      </v-card>
    </v-flex>
    <v-flex xs6 py-4 pr-4 pl-2 style="position: relative">
      <v-card class="ml-2 mr-3 my-4 maincontent">
        <v-card-title style="flex-direction: column; align-items: stretch; height: 100%">
          <span class="subheading" style="flex: 0 0 auto">{{ $t('Pilot.FileTransfert.DownloadStatus') }}</span>
          <template v-if="loadingData">
            <v-progress-circular
              :width="10"
              indeterminate
              :size="200"
              color="primary"
              style="align-self: center; margin-bottom: auto; margin-top: auto"
            >
              <span class="normal">{{ $t('Pilot.Graphics.LoadingData') }}</span>
            </v-progress-circular>
          </template>
          <template v-else-if="mission.downloadFileStatus && mission.downloadFileStatus.length > 0">
            <v-layout row wrap mt-2 style="flex: 0 0 auto">
              <v-flex class="centercontent" xs4 pr-2>
                <span class="body-2">{{ $t('Pilot.FileTransfert.Cycle') }}</span>
              </v-flex>
              <v-flex class="centercontent" xs4 pl-2 pr-2>
                <span class="body-2">{{ $t('Pilot.FileTransfert.NavFieldName') }}</span>
                <v-btn small icon @click="downloadFile(`/api/gliderfile/download/gli/${mission.misId}/all`)">
                  <v-icon>mdi-download</v-icon>
                </v-btn>
              </v-flex>
              <v-flex class="centercontent" xs4 pl-2>
                <span class="body-2">{{ $t('Pilot.FileTransfert.PldFieldName') }}</span>
                <v-btn small icon @click="downloadFile(`/api/gliderfile/download/pld1/${mission.misId}/all`)">
                  <v-icon>mdi-download</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout row wrap style="flex: 1 0; overflow: auto; align-content: flex-start">
              <template v-for="status in filesStatus">
                <v-flex class="centercontent" :key="`cycle_${status.yosCycle}`" xs4 pr-2>{{ status.yosCycle }}</v-flex>
                <v-flex class="centercontent" :key="`nav_${status.yosCycle}`" xs4 pl-2 pr-2>
                  <v-btn
                    small
                    icon
                    v-if="status.navDownloadable"
                    @click="downloadFile(`/api/gliderfile/download/gli/${mission.misId}/${status.yosCycle}`)"
                  >
                    <v-icon>mdi-download</v-icon>
                  </v-btn>
                  <template v-else-if="status.navRunning">
                    <v-progress-circular
                      :rotate="360"
                      indeterminate
                      color="primary"
                      :size="30"
                      :width="4"
                    ></v-progress-circular>
                  </template>
                  <template v-else-if="status.nav != null || config.specificsNavFiles.indexOf(status.yosCycle) >= 0">
                    <v-progress-circular
                      :rotate="360"
                      color="primary"
                      :size="30"
                      :width="4"
                      :value="status.nav == null ? 0 : status.nav"
                    >
                      {{ status.nav }}
                    </v-progress-circular>
                  </template>
                  <v-btn
                    @click.prevent="addToNavRequested(status.yosCycle)"
                    :title="$t('Pilot.FileTransfert.AddToRequested')"
                    small
                    icon
                    v-if="
                      mission.misActifOn &&
                      accessConfigFileTransfert.enable &&
                      (status.nav == null || !status.navDownloadable) &&
                      config.specificsNavFiles.indexOf(status.yosCycle) == -1
                    "
                  >
                    <v-icon>mdi-file-plus</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex class="centercontent" :key="`pld_${status.yosCycle}`" xs4 pl-2>
                  <v-btn
                    small
                    icon
                    v-if="status.pld1Downloadable"
                    @click="downloadFile(`/api/gliderfile/download/pld1/${mission.misId}/${status.yosCycle}`)"
                  >
                    <v-icon>mdi-download</v-icon>
                  </v-btn>
                  <template v-else-if="status.pld1Running">
                    <v-progress-circular
                      :rotate="360"
                      indeterminate
                      color="primary"
                      :size="30"
                      :width="4"
                    ></v-progress-circular>
                  </template>
                  <template v-else-if="status.pld1 != null || config.specificsPldFiles.indexOf(status.yosCycle) >= 0">
                    <v-progress-circular
                      :rotate="360"
                      color="primary"
                      :size="30"
                      :width="4"
                      :value="status.pld1 == null ? 0 : status.pld1"
                    >
                      {{ status.pld1 }}
                    </v-progress-circular>
                  </template>
                  <v-btn
                    @click.prevent="addToPldRequested(status.yosCycle)"
                    :title="$t('Pilot.FileTransfert.AddToRequested')"
                    small
                    icon
                    v-if="
                      mission.misActifOn &&
                      accessConfigFileTransfert.enable &&
                      (status.pld1 == null || !status.pld1Downloadable) &&
                      config.specificsPldFiles.indexOf(status.yosCycle) == -1
                    "
                  >
                    <v-icon>mdi-file-plus</v-icon>
                  </v-btn>
                </v-flex>
              </template>
            </v-layout>
          </template>
          <template v-else>
            <span class="display-2" style="margin: auto">{{ $t('Pilot.FileTransfert.NoDataAvailable') }}</span>
          </template>
        </v-card-title>
      </v-card>
    </v-flex>
    <!-- Dialog de chargement... -->
    <v-dialog v-model="loading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          {{ status }}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script setup lang="ts">
import { ref, computed, watch, onMounted, getCurrentInstance } from 'vue'
//@ts-ignore
import draggable from 'vuedraggable'
import deepEqual from 'deep-equal'
import sortBy from 'lodash/sortBy'
import types from '@/store/all-mutation-types'
import { buildDataMissionKey, DataPoolMissionKeys } from '@/enum/DataPool'
import { GliderFileType } from '@/enum/GliderFileType'
import { IFileTransfertConfig } from '@/models/iris/fileTransfert/IFileTransfertConfig'
import { MissionUi } from '@/models/ui/MissionUi'
import { IrisConfigContainer } from '@/models/iris/IrisConfigContainer'
import { AloGliderFileShort } from '../../models/alo/AloGliderFileShort'
import apiHelpers from '@/utils/api'
import { ensureStringArray, formatListFileEntry, parseListFileEntry } from '@/utils/fileTransfertList'
import missionApi from '../../api/mission'
import { SecurityItemsKeys } from '../../enum/SecurityItems'
import { VuetifyConfirmObject } from 'vuetify-confirm'
import store from '@/store'
import { AloMission } from '@/models/alo/AloMission'
import { i18n } from '@/locale/vueI18n'

const props = defineProps<{
  mission: AloMission
}>()

// Accès aux plugins Vue via l'instance (Vue 2 + Composition API)
const instance = getCurrentInstance()
const $confirm = instance?.proxy?.$confirm
const boxes = ref([])
const config = ref({
  enableDownload: true,
  enableCatchUpNav: true,
  enableCatchUpPld: true,
  nbDownLastNavFile: 1,
  nbDownLastPldFile: 1,
  priority: ['standard', 'listFixed', 'multi_yo'],
  firstFile: 'false',
  lastFile: 'false',
  specificsNavFiles: [] as Array<number>,
  specificsPldFiles: [] as Array<number>,
  // Entrées de `list_file` que le front ne sait pas décoder : conservées telles
  // quelles et ré-émises au save, sinon un format IRIS inconnu serait détruit.
  otherFiles: [] as Array<string>,
  specificsFilesNf: [] as Array<string>,
  filesRequested: [] as Array<string>,
})

const newFileNfInput = ref('')

const multiYoFileItems = computed(() => [
  { text: i18n.t('Pilot.FileTransfert.OptionNone').toString(), value: 'false' },
  { text: i18n.t('Pilot.FileTransfert.NavFieldName').toString(), value: 'nav' },
  { text: i18n.t('Pilot.FileTransfert.PldFieldName').toString(), value: 'sci' },
  { text: i18n.t('Pilot.FileTransfert.OptionAll').toString(), value: 'all' },
])

const loading = computed(() => store.myGetters.fileTransfertLoading)
const status = computed(() => store.myGetters.gliderStatus)
const missionSecurity = computed(() => props.mission.security)
const accessConfigFileTransfert = computed(
  () => props.mission.security[SecurityItemsKeys.PILOT_DETAIL_FILE_TRANSFERT_CONFIG],
)
const loadingData = computed(() => !props.mission._downloadFileStatusLoaded)
const filesStatus = computed(() => {
  if (!props.mission.downloadFileStatus || !Array.isArray(props.mission.downloadFileStatus)) {
    return []
  }
  // @ts-ignore
  return Object.values(
    props.mission.downloadFileStatus.reduce((acc: any, value: any) => {
      // on ajoute la ligne si le fichier est downloadable ou la mission est active
      // if(props.mission.misActifOn || value.isDownloadable) {
      // filtre les cycles 0
      if (value.targetYosCycle != 0) {
        acc[value.targetYosCycle] = acc[value.targetYosCycle] || {
          yosCycle: value.targetYosCycle,
          nav: null,
          pld1: null,
          pld2: null,
        }
        if (value.gliderFileType == GliderFileType.gli) {
          acc[value.targetYosCycle].nav = value.dataProgression
          acc[value.targetYosCycle].navDownloadable = value.isDownloadable
          acc[value.targetYosCycle].navRunning = value.isRunning
        } else if (value.gliderFileType == GliderFileType.pld1) {
          acc[value.targetYosCycle].pld1 = value.dataProgression
          acc[value.targetYosCycle].pld1Downloadable = value.isDownloadable
          acc[value.targetYosCycle].pld1Running = value.isRunning
        } else if (value.gliderFileType == GliderFileType.pld2) {
          acc[value.targetYosCycle].pld2 = value.dataProgression
          acc[value.targetYosCycle].pld2Downloadable = value.isDownloadable
          acc[value.targetYosCycle].pld2Running = value.isRunning
        }
      }
      // }
      return acc
    }, {}),
  )
})

const downloadStatus = computed(() => null)

const originalFileTransfertConfig = computed(() => {
  if (props.mission.gliId == null) return null
  return store.myGetters.originalFileTransfertConfigs[props.mission.gliId]
})

const modifiedFileTransfertConfig = computed(() => {
  if (props.mission.gliId == null) return null
  return store.myGetters.modifiedFileTransfertConfigs[props.mission.gliId]
})

const btnActif = computed(() => {
  const configCopy = {}
  if (originalFileTransfertConfig.value) {
    loadConfig(configCopy, originalFileTransfertConfig.value)
  }
  return config.value.enableDownload && !deepEqual(configCopy, config.value) && !loading.value
})

const orderedSpecificsNavFiles = computed(() => sortBy(config.value.specificsNavFiles, Number))
const orderedSpecificsPldFiles = computed(() => sortBy(config.value.specificsPldFiles, Number))

// Multi-yo first/last file : IRIS utilise 'nav'|'sci'|'all' (string) et `false`
// (boolean) pour « aucun ». Le select travaille en chaîne ; on renvoie le booléen
// false à IRIS pour « aucun » (fidèle au format retourné).
function normalizeMultiYoFile(v: string | boolean | null | undefined): string {
  return typeof v === 'string' ? v : 'false'
}
function serializeMultiYoFile(v: string): string | boolean {
  return v === 'false' ? false : v
}

function loadConfig(target: any, configData: IrisConfigContainer<IFileTransfertConfig>) {
  if (configData) {
    target.enableDownload = configData.mod_settings.EnabledMOD['module-FileTransfer']
    target.enableCatchUpNav = configData.mod_settings.FileTransfer_standard.caught_old_file_nav
    target.enableCatchUpPld = configData.mod_settings.FileTransfer_standard.caught_old_file_sci
    target.nbDownLastNavFile = configData.mod_settings.FileTransfer_standard.nb_file_nav
    target.nbDownLastPldFile = configData.mod_settings.FileTransfer_standard.nb_file_sci
    target.priority = configData.mod_settings.FileTransfer
      ? [...configData.mod_settings.FileTransfer.priority_transferType]
      : []
    // multi_yo : si absent de la priorité (config legacy), on l'ajoute en dernière position
    if (target.priority.indexOf('multi_yo') == -1) target.priority.push('multi_yo')
    // IRIS renvoie `false` (boolean) pour « aucun » → normalisé en chaîne 'false'
    // (les autres valeurs 'nav'/'sci'/'all' sont des chaînes) pour le v-model du select.
    target.firstFile = normalizeMultiYoFile(configData.mod_settings.FileTransfer_multiYo?.first_file)
    target.lastFile = normalizeMultiYoFile(configData.mod_settings.FileTransfer_multiYo?.last_file)
    const pld = [] as Array<number>
    const nav = [] as Array<number>
    const other = [] as Array<string>
    // Le multi-files IRIS a changé le format : `nav|7` est ré-écrit `n7`. On lit
    // les deux (cf utils/fileTransfertList) et on préserve l'inconnu.
    ensureStringArray(configData.mod_settings.FileTransfer_listFile.list_file).forEach(it => {
      const entry = parseListFileEntry(it)
      if (entry == null) other.push(it)
      else if (entry.kind == 'nav') nav.push(entry.cycle)
      else pld.push(entry.cycle)
    })
    target.specificsNavFiles = nav
    target.specificsPldFiles = pld
    target.otherFiles = other
    target.specificsFilesNf = ensureStringArray(configData.mod_settings.FileTransfer_listFile.list_file_nf)
    target.filesRequested = ensureStringArray(configData.mod_settings.FileTransfer_state.gli_file_waiting)
  }
}

function orderup(item: string) {
  const index = config.value.priority.indexOf(item)
  const newIndex = (config.value.priority.length + index - 1) % config.value.priority.length
  config.value.priority.splice(newIndex, 0, config.value.priority.splice(index, 1)[0])
}

function orderdown(item: string) {
  const index = config.value.priority.indexOf(item)
  const newIndex = (config.value.priority.length + index + 1) % config.value.priority.length
  config.value.priority.splice(newIndex, 0, config.value.priority.splice(index, 1)[0])
}

function layoutBoxes() {
  // Animation logic removed for simplicity in script setup
}

function addToNavRequested(cycle: number) {
  if (config.value.specificsNavFiles.length > 10) {
    config.value.specificsNavFiles = config.value.specificsNavFiles.slice(0, 10)
    if ($confirm && $t) {
      $confirm(i18n.t('Pilot.FileTransfert.TooMuchFile').toString(), {
        title: i18n.t('Admin.Warning'),
        buttonTrueText: 'Ok',
        buttonFalseText: '',
      } as VuetifyConfirmObject)
    }
  } else {
    config.value.specificsNavFiles.push(cycle)
  }
}

function addToPldRequested(cycle: number) {
  if (config.value.specificsPldFiles.length > 10) {
    config.value.specificsPldFiles = config.value.specificsPldFiles.slice(0, 10)
    if ($confirm && $t) {
      $confirm(i18n.t('Pilot.FileTransfert.TooMuchFile').toString(), {
        title: i18n.t('Admin.Warning'),
        buttonTrueText: 'Ok',
        buttonFalseText: '',
      } as VuetifyConfirmObject)
    }
  } else {
    config.value.specificsPldFiles.push(cycle)
  }
}

function removeFromNavRequested(cycle: number) {
  config.value.specificsNavFiles.splice(config.value.specificsNavFiles.indexOf(cycle), 1)
}

function removeFromPldRequested(cycle: number) {
  config.value.specificsPldFiles.splice(config.value.specificsPldFiles.indexOf(cycle), 1)
}

function addFileNf() {
  const value = newFileNfInput.value.trim()
  // ajout tel quel, on évite juste les doublons exacts (règle de format à venir côté client)
  if (value && config.value.specificsFilesNf.indexOf(value) == -1) {
    config.value.specificsFilesNf.push(value)
  }
  newFileNfInput.value = ''
}

function removeFileNf(value: string) {
  config.value.specificsFilesNf.splice(config.value.specificsFilesNf.indexOf(value), 1)
}

function validateConfig() {
  store.myActions.GLIDER_UPDATE_MODIFIED_FILE_TRANSFERT({
    itemId: props.mission.gliId!,
    newProperties: {
      mod_settings: {
        EnabledMOD: {
          'module-FileTransfer': config.value.enableDownload,
        },
        FileTransfer: {
          priority_transferType: [...config.value.priority],
        },
        FileTransfer_multiYo: {
          // 'false' → booléen false (fidèle à IRIS), sinon la chaîne 'nav'/'sci'/'all'
          first_file: serializeMultiYoFile(config.value.firstFile),
          last_file: serializeMultiYoFile(config.value.lastFile),
        },
        FileTransfer_listFile: {
          list_file: [
            ...config.value.specificsNavFiles.map(it => formatListFileEntry('nav', it)),
            ...config.value.specificsPldFiles.map(it => formatListFileEntry('pld', it)),
            ...config.value.otherFiles,
          ],
          list_file_nf: [...config.value.specificsFilesNf],
        },
        FileTransfer_standard: {
          caught_old_file_nav: config.value.enableCatchUpNav,
          caught_old_file_sci: config.value.enableCatchUpPld,
          nb_file_nav: config.value.nbDownLastNavFile,
          nb_file_sci: config.value.nbDownLastPldFile,
        },
      },
    },
  })
}

function saveConfig() {
  validateConfig()
  store.myActions.GLIDER_IRIS_FILE_TRANSFERT_SAVE_REQUEST(props.mission.gliId!)
}

function restoreConfig() {
  store.myActions.GLIDER_CANCEL_MODIFIED_FILE_TRANSFERT(props.mission.gliId!)
}

function downloadFile(url: string) {
  apiHelpers.downloadFile(url, '.csv')
}

// Watch for mission changes
watch(
  () => props.mission,
  newValue => {
    if (newValue.misId != null) {
      store.myActions.MISSION_ENSURE_DOWNLOAD_FILE_STATUS(newValue.misId)
    }
    if (props.mission.misActifOn && accessConfigFileTransfert.value.enable && newValue.gliId != null) {
      store.myActions.GLIDER_IRIS_FILE_TRANSFERT_REQUEST(newValue.gliId)
    }
  },
)

// Watch for priority changes
watch(
  () => config.value.priority,
  (newValue: Array<string>) => {
    layoutBoxes()
  },
)

// Watch for modifiedFileTransfertConfig changes
watch(modifiedFileTransfertConfig, (newConfig: IrisConfigContainer<IFileTransfertConfig> | null) => {
  if (newConfig) {
    loadConfig(config.value, newConfig)
  }
})

// Watch for config changes
watch(
  config,
  () => {
    validateConfig()
  },
  { deep: true },
)

// Created lifecycle
if (props.mission.misId != null) {
  store.myActions.MISSION_ENSURE_DOWNLOAD_FILE_STATUS(props.mission.misId)
}
if (props.mission.misActifOn && accessConfigFileTransfert.value.enable && props.mission.gliId != null) {
  store.myActions.GLIDER_IRIS_FILE_TRANSFERT_REQUEST(props.mission.gliId).then(() => {
    if (modifiedFileTransfertConfig.value) {
      loadConfig(config.value, modifiedFileTransfertConfig.value)
    }
  })
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>
.subheading,
.body-2 {
  font-weight: bold;
}

.btnup {
  position: absolute;
  top: -6px;
  right: -7px;
}
.btnup:hover {
  position: absolute;
}
.btndown {
  position: absolute;
  bottom: -6px;
  right: -7px;
}
.btndown:hover {
  position: absolute;
}

.position {
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  width: 31px;
  background-color: #eee;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

.flex-container {
  display: flex;
  flex-direction: column;
  position: relative;
}

.disable {
  position: relative;
}

.disable::before {
  position: absolute;
  content: '';
  left: 0px;
  top: 0px;
  right: 0px;
  bottom: 0px;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 1;
}

.centercontent {
  border-bottom: 1px solid #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 41px;
  text-align: center;
}
</style>
